import axiosService from '../axios'

export const list = (params?: any) => {
  return axiosService({
    url: '/api.quotation-form',
    method: 'get',
    params,
  })
}

export const listAll = (params?: any) => {
  return axiosService({
    url: '/api.quotation-form/all',
    method: 'get',
    params,
  })
}

export const count = () => {
  return axiosService({
    url: `/api.quotation-form/count-pending`,
    method: 'get',
  })
}

export const get = (id: number) => {
  return axiosService({
    url: `/api.quotation-form/${id}`,
    method: 'get',
  })
}

export const exportSalary = (data: any) => {
  return axiosService({
    url: `/api.quotation-form/export-salary`,
    method: 'put',
    data,
  })
}

export const update = (id: number, data: any) => {
  return axiosService({
    url: `/api.quotation-form/${id}`,
    method: 'put',
    data,
  })
}

export const exportQuotation = (id: number, data: any) => {
  return axiosService({
    url: `/api.quotation-form/${id}/export-quotation`,
    method: 'put',
    data,
  })
}

export const reject = (id: number, data: any) => {
  return axiosService({
    url: `/api.quotation-form/${id}/reject`,
    method: 'put',
    data,
  })
}

export const approve = (id: number, data: any) => {
  return axiosService({
    url: `/api.quotation-form/${id}/approve`,
    method: 'put',
    data,
  })
}

export const apply = (id: number, data: any) => {
  return axiosService({
    url: `/api.quotation-form/${id}/apply`,
    method: 'put',
    data,
  })
}

export const process = (id: number, data: any) => {
  return axiosService({
    url: `/api.quotation-form/${id}/process`,
    method: 'put',
    data,
  })
}

export const remake = (id: number, data: any) => {
  return axiosService({
    url: `/api.quotation-form/${id}/remake`,
    method: 'put',
    data,
  })
}

export const updatePriceInsurance = (id: number, data: any) => {
  return axiosService({
    url: `/api.quotation-form/${id}/insurance`,
    method: 'put',
    data,
  })
}

export const destroy = (id: number) => {
  return axiosService({
    url: `/api.quotation-form/${id}`,
    method: 'delete',
  })
}

export const createQuoteLine = (id: number, data: any) => {
  return axiosService({
    url: `/api.quotation-form/${id}/quote-line`,
    method: 'post',
    data,
  })
}

export const create = (data: any) => {
  return axiosService({
    url: '/api.quotation-form',
    method: 'post',
    data,
  })
}

export const updateQuoteLine = (id: number, data: any) => {
  return axiosService({
    url: `/api.quote-line/${id}`,
    method: 'put',
    data,
  })
}
